import { HttpClient } from '@adapters/HttpClient';

export interface ExternalExcludedProduct {
  id: number;
  external_variant_id: string;
  shop_id: number;
  shop_name?: string;
  external_product_id: string;
  external_shop_product_title?: string;
  excluded_products_amount_handling: 'remove' | 'add_to_shipping';
  created_at: string;
}

export interface CreateExclusionPayload {
  external_variant_id: string;
  shop_id: number;
  external_product_id: string;
  external_shop_product_title?: string;
  excluded_products_amount_handling: 'remove' | 'add_to_shipping';
}

export interface CreateExclusionResponse {
  success: boolean;
  message: string;
  data?: ExternalExcludedProduct;
}

export interface DeleteExclusionResponse {
  success: boolean;
  message: string;
}

export class ExternalProductsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene la lista de productos externos excluidos
   * @param shopId ID de la tienda (opcional, para filtrar)
   */
  async getExcludedProducts(
    shopId?: number
  ): Promise<ExternalExcludedProduct[]> {
    const params: Record<string, any> = {};
    if (shopId !== undefined && shopId !== null) {
      params.shop_id = shopId;
    }

    console.log('🔍 ExternalProductsApiAdapter - getExcludedProducts:', {
      shopId,
      params,
    });

    const response = await this.httpClient.get<any>(
      '/excluded-products',
      params
    );

    console.log('🔍 ExternalProductsApiAdapter - Response:', {
      response,
      isArray: Array.isArray(response),
      data: response?.data,
    });

    const list = Array.isArray(response) ? response : response?.data ?? [];
    return list;
  }

  /**
   * Crea una nueva exclusión de producto externo
   */
  async createExclusion(
    payload: CreateExclusionPayload
  ): Promise<CreateExclusionResponse> {
    const response = await this.httpClient.post<CreateExclusionResponse>(
      '/excluded-products',
      payload
    );

    return {
      success: response?.success ?? true,
      message: response?.message || 'Exclusión creada exitosamente',
      data: response?.data,
    };
  }

  /**
   * Elimina una exclusión de producto externo
   */
  async deleteExclusion(
    id: number
  ): Promise<DeleteExclusionResponse> {
    const response = await this.httpClient.delete<DeleteExclusionResponse>(
      `/excluded-products/${id}`
    );

    return {
      success: response?.success ?? true,
      message: response?.message || 'Exclusión eliminada exitosamente',
    };
  }
}
